import React from 'react';
import { Bot } from 'lucide-react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo">
          <Bot size={48} />
        </div>
        <h1>Enterprise AI Platform</h1>
        <div className="loading-bar">
          <div className="loading-bar-progress" />
        </div>
        <p>Loading your workspace...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
